export default {
    filtro: {
        periodo_padrao: 'Standard Period',
        periodo_personalizado: 'Custom period',
        mais_filtros: 'More Filters',
        vns: 'VNS',
        recipiente: 'Recipient/ID',
        empresa: 'Company',
        paciente: 'Patient',
        tipo_integracao: 'Type of Integration',
        status: 'Status',
        status_filtro: {
            todos: 'All',
            novo: 'New',
            ativo: 'Online',
            desconectado: 'Disconnected',
            analise: 'Under Analysis',
            offline: 'Offline'
        },
        erros: {
            label: 'Errors',
            dexpara: 'All errors from mapping',
            exame: 'Exam Mapping Errors',
            metodo: 'Method mapping errors',
            material: 'Material mapping errors'
        },
        filtrar_button: 'Filter',
        limpar_button: 'Clear Filters'
    },
    automacao: {
        titulo: 'Orders and Results',
        ordens: 'Orders',
        resultados: 'Results'
    },
    link: {
        titulo: 'Orders and Results - Support',
        ordens: 'Orders',
        resultados: 'Results',
        numero_pedido: 'Order Number'
    },
    lis: {
        titulo: 'Orders and Results - Lis'
    },
    periodos: {
        trinta_minutos: '30 minutes ago',
        uma_hora: '1 hour ago',
        hoje: 'Today',
        sete_dias: 'Last 7 days',
        mes_atual: 'Current month',
        mes_anterior: 'Last month',
        ano_atual: 'Current year',
        ano_anterior: 'Last year'
    },
    messages:{
        resend: {
            success: 'Resend successful!',
            error: 'Error resubmitting!',
            recipient_diference: 'To resend the result, the recipient number must be different from the original!',
            reason_required: 'Please fill in the reason for changing the recipient!'
        },
        reprint: {
            success: 'Print done!',
            error: 'Error printing label!'
        },
        file_not_found: 'File not found!',
        file_error: 'Error reading file!',
        getObservation: {
            success: 'The results will be requested from the Lab. of support!',
            error: 'Error fetching results!'
        }
    },
    table: {
        fields: {
            recipiente: 'Recipient/ID',
            informacoes: 'Information',
            vns: 'VNS',
            empresa: 'Company',
            paciente: 'Patient',
            ultima_atualizacao: 'Last update',
            acoes: 'Actions'
        },
        status: {
            ordem_recebida: 'Order Received',
            no_equipamento: 'Processed in EQPT',
            resultados: 'Result Sent',
            completos: 'Complete results',
            erro_dexpara: 'Error in Mapping',
            erro_suporte: 'Support / Origin Error'
        }
    },
    modal: {
        titulo: 'Exams',
        reenviar_ordem: 'Resend Order',
        reenviar_resultado: 'Resend Result',
        reemprimir_etiqueta: 'Reprint Label',
        dados: 'Data',
        arquivo: 'File',
        lis_bruto: 'LIS raw',
        lis_formatado: 'LIS formatted',
        vns_bruto: 'VNS raw',
        vns_formatado: 'VNS formatted',
        table: {
            recipiente: 'Recipient/ID',
            paciente: 'Patient',
            athlete: 'Athlete/ID',
            horario: 'Schedule',
            exame_lis: 'Exam LIS',
            exame_vns: 'Integration Exam',
            status: 'Status',
            acoes: 'Actions',
            erro: 'Error'
        },
        details: {
            ordem_exam_code_lis: 'Order LIS',
            ordem_exam_code_vns: 'Order of Integration',
            resultado_exam_code_lis: 'Result LIS',
            resultado_exam_code_vns: 'Integration Result',
            metodo_origem: 'Origin method',
            metodo_destino: 'Destination method',
            valor: 'Value',
            unidade: 'Unit',
            texto_referencia: 'Reference text',
            estrutura_referencia: 'Reference structure',
            tipo_resultado: 'Result Type',
            tipo_resultado_decimal: 'Decimal',
            tipo_resultado_alfanumerico: 'Alphanumeric',
            processado: 'Processed in',
            status_protocolo: 'Protocol Status',
            motivo_revisao: 'Reason for Result Review',
            usuario_revisao: 'User who reviewed the result',
            protocolo_status: {
                available: 'Available',
                blocked: 'Blocked',
                review: 'In Review',
                reviewed: 'Reviewed',
                sent: 'Sent',
                canceled: 'Canceled'
            },
            mapping: {
                exam_originCode: 'Exam LIS',
                exam_destinationCode: 'Integration Exam',
                specimen_originCode: 'Material LIS',
                specimen_destinationCode: 'Integration Material',
                method_originCode: 'Method LIS',
                method_destinationCode: 'Integration Method',
                parent_exam_originCode: 'Parent Exam LIS',
                parent_exam_destinationCode: 'Integration Parent Exam'
            },
            exame_lis: 'Origin Exam',
            exame: 'Exam',
            origem: 'Origin',
            destino: 'Destination',
            material_lis: 'Origin Material',
            material: 'Material',
            numero_pedido: 'Order Number',
            metodo: 'Method',
            material_adicional: 'Additional Material',
            complemento_material_lis: 'Complement Origin',
            complemento_material: 'Complement Destination',
            especie: 'Specie',
            raca: 'Breed',
            pelagem: 'Coat',
            porte: 'Size',
            exames: 'Exams',
            complementos_exames: 'Exam Complements',
            controle_qualidade: 'Quality Control',
            pet: 'Pet',
            erros_suporte: 'Support Errors',
            erros_origem: 'Source Errors',
            mensagem: 'Message',
            data_hora: 'Date and Hour',
            protocolo: 'Protocol',
            editar_recipiente: 'Edit Recipient',
            recipiente_alterado: 'Recipient Changed',
            recipientes_reenviados: 'Resent Recipients',
            novo_recipiente: 'New Recipient',
            vs_usuario_id: 'VS User ID',
            vs_usuario_name: 'VS User Name',
            criado_em: 'Created On',
            motivo: 'Reason',
            resend: {
                change_recipient: "Change the recipient number and resend the exam result:",
                fix_recipient_number: "Fix the recipient number:",
                fix_recipient_number_placeholder: "enter the new recipient number",
                edit_reason: "Reason for Change:",
                edit_reason_placeholder: "Provide the reason ...",
                resend_result: "Resend Result"
            },
            changed: {
                original_recipient: "Original Recipient:",
                user_id: "User ID:",
                user_name: "User Name:",
                reason: "Reason:"
            }
        },
        getObservation :{
            pending: 'Search pending results',
            all: 'Fetch and resend all results'
        },
        file_detail: {
            empty: 'No files found!',
            reenviar_arquivo: 'Resend file',
            arquivo: 'File',
            etapa: 'Stage',
            reenviar: 'Resend'
        },
        recipiente: {
            exames: 'Exams',
            horario: 'Schedule',
            arquivos: 'Files',
            status: 'Status',
            acoes: 'Actions',
            resultado: 'Result',
            ordem: 'Order',
            carregando_ordens: 'Loading Orders',
            carregando_resultados: 'Loading Results'
        },
        report_result_detail: {
            resultado: 'Result',
            inconclusivo: 'Inconclusive',
            reagente: 'Reagent',
            nao_reagente: 'Non-Reagent',
            enviar_resultados: 'Send Result(s)',
            informe_resultado_exame: 'Report the result for the Exam:',
            exame: 'Exam:',
            sem_de_para: 'does not have a Mapping for destination integration at this order moment',
            resultado_recebido: 'Result received successfully!',
            erro_transmitir_resultado: 'Error transmitting result, check the console!'
        }
              
    }
}
